import React, { useState } from "react";
import Delete from "../../src/Images/Delete.png";
import crosssimgiocn from "../../src/Images/crosssimgiocn.png";
import cameralogo from "../../src/Images/cameralogo.png";
import HttpClient from "../../src/utils/HttpClient";
import { useSelector } from "react-redux";
import { confirmAlert } from 'react-confirm-alert'
import toast from "react-hot-toast";

const Editlogogetmodal = ({ closemodal, setUrl, url, updateForm, setIsUpdate }) => {
  const { UserProfileID } = useSelector((state) => state.app);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(UserProfileID?.businessProfilePic || url || "");
  const [hasData, setHasData] = useState(false);
  const [error, setError] = useState("");

  const imageUpload = async (file) => {
    if (!file) return; // Ensure there is a file to upload
    setError("");
    setLoading(true);
    const formData = new FormData();
    formData.append("image", file);

    try {
      const res = await HttpClient.fileUploadWithoutAuth("image-upload", "POST", formData);
      if (res.status) {
        setData(res.data.url);
        setHasData(true);
      } else {
        setError(res?.message || "Error while uploading image");
        console.log("Error while uploading image");
      }
    } catch (error) {
      setError("Error while uploading image");
      console.error("Upload failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (event) => {
    setError("");
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (!validImageTypes.includes(file.type)) {
        setError("Error: Please upload a valid image file (PNG/JPEG)");
        return;
      }

      // Validate file size (5MB = 5242880 bytes)
      const maxSize = 5 * 1024 * 1024;
      if (file.size > maxSize) {
        setError("Error: File size must be less than or equal to 5MB");
        return;
      }

      imageUpload(file);
    }
  };

  const removeProfileImage = async (e) => {
    e.preventDefault();
    updateForm("businessProfilePic", "");
    setUrl("");
    setData("");
    setHasData(false);
    setIsUpdate(true)
  };

  return (
    <div className="uploabannermodalbgshadow">
      <div className="editlofgogaemodalbg">
        <h5 className="mt-2 p-0 m-3">Update Profile Picture</h5>
        <div className="remove-icon-image-new dettetstyyiocnnhui">
          <img src={Delete} alt="Delete icon" onClick={(e) => removeProfileImage(e)} />
        </div>
        <div className="crossdivicon" onClick={() => closemodal()} style={{ cursor: "pointer" }}>
          <i className="fa-solid fa-xmark"></i>
        </div>
        <hr />

        <div className="editprofile">
          {data ? (
            <div className="cameralogodivimgabslt">
              <div>
                <img
                  style={{
                    height: "100px",
                    width: "100px",
                    borderRadius: "50%",
                  }}
                  src={data}
                  alt="Profile logo"
                />
              </div>
            </div>
          ) : (
            <div className="cameralogodivimgabslt">
              <div className="cameralogodivimg">
                <img src={cameralogo} alt="Camera logo" />
              </div>
              <p className="uplsdttxttppshji">Upload Logo</p>
              <p className="pixelsttxttppio">
                (Pixel Size: 140 x 140 PNG/JPEG)
              </p>
            </div>
          )}
        </div>
        <div>
          <p className="error pl-4">{error != '' && error}</p>
        </div>

        <div className="browoefilesabbddivforprofikeflx">
          <label className="brwdffioevbtgbjhbtnmewlogpro">
            Browse File
            <input
              type="file"
              className="inkspottsrrdiv"
              name="profilePhoto"
              onChange={handleFileChange}
              style={{ display: "none" }} // Hide the input visually
            />
          </label>
          {hasData && (
            <button
              className="svavtatvvbtnnm"
              onClick={() => {
                updateForm("businessProfilePic", data);
                setUrl(data);
                setData("");
                setHasData(false);
                setIsUpdate(true)
                closemodal();
              }}
            >
              Save
            </button>
          )}
        </div>

        {loading && (
          <div className="loader-overlay">
            <div className="loader"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Editlogogetmodal;
